import { request } from "./http";

export interface ClosedPosition {
  symbol: string;
  side: string;
  qty: string;
  avg_entry: string;
  avg_exit: string;
  realized_pnl: string;
  opened_at: string;
  closed_at: string;
}

export interface PositionHistoryQuery {
  trading_account_id: string;
  from_ts?: string;
  to_ts?: string;
  limit?: number;
}

export const positionsApi = {
  history: (q: PositionHistoryQuery) => {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(q)) {
      if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
    }
    return request<ClosedPosition[]>(`/api/v1/positions/history?${p.toString()}`);
  },
};
